<div class="search-bar-container">
  <form class="search-bar-form" role="search" aria-label="search bar form" [formGroup]="searchForm">
    <div class="input-group">
      <input
        #searchBar
        type="text"
        class="form-control form-control-sm"
        placeholder="Search placeholder"
        i18n-placeholder
        tabindex="0"
        formControlName="search"
        (keyup)="emitSearchFormChanges()"
        (keyup.enter)="emitGoToSearchResultsPage(searchBar.value)"
      />

      <div class="input-group-append">
        <button
          aria-label="search"
          type="button"
          class="btn btn-sm btn-outline-secondary search-button"
          [disabled]="!searchBar.value.length || searchBar.value.length === 0"
          (click)="emitGoToSearchResultsPage(searchBar.value)"
        >
          <span class="sr-only" i18n="@@SEARCH">SEARCH</span>
          <img alt="search icon" [src]="'assets/images/icons/search-white.svg' | staticFileHash" />
        </button>
      </div>
    </div>
  </form>

  @if (isActiveSearch) {
    <div class="search-results-container">
      @if (searchResults.length > 0) {
        <div class="search-results">
          @for (product of searchResults; track product.id) {
            <div class="search-results__item">
              <a class="" href [sfProductLink]="product" (click)="clickSearchProduct()">
                @if (product.imageUrl) {
                  <img
                    class="search-results__item-thumb"
                    ngSrcset="50w, 100w"
                    height="50"
                    width="50"
                    [ngSrc]="product.imageUrl"
                    [alt]="product | translateProductField: 'title'"
                    [loaderParams]="{ product: true, fallback: missingProductImageUrl }"
                    (error)="product.imageUrl = missingProductImageUrl"
                  />
                }
                <div
                  class="search-results__item-title"
                  [innerHTML]="product | translateProductField: 'title' | highlightText: searchBar.value"
                ></div>
              </a>
            </div>
          }
        </div>
      }
      @if (searchResults.length === 0) {
        <div class="search-results search-results__empty">
          <p i18n="@@noSearchResults">There were no results for your search.</p>
        </div>
      }
    </div>
  }
</div>
